// extracted by mini-css-extract-plugin
module.exports = {"container":"AccessRestricted_container__8XnoQ","info":"AccessRestricted_info__39fDd","link":"AccessRestricted_link__180Wm"};